import React from 'react';

import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import InfoBox from 'components/InfoBox/InfoBox';
import organizationsApi from 'config/api/organizations/organizations';
import QUERY_KEYS from 'config/api/QUERY_KEYS';
import info_boxes_messages from 'messages/info_boxes_messages';
import userDataStorage from 'storages/userDataStorage';

type Props = {
  action: () => void;
};

const DashboardInfoBoxRetentionForAccountOwner: React.FC<Props> = ({ action }) => {
  const { t } = useTranslation();

  // @ts-ignore
  const { organization } = userDataStorage.get() || {};

  const { data: retentionData } = useQuery(QUERY_KEYS.REMAINING_RETENTION_DAYS, () =>
    organizationsApi.getOrganizationRemainingRetentionDays(organization),
  );

  if (!retentionData) return null;

  return (
    <InfoBox
      action={action}
      buttonLabel={t(info_boxes_messages.retention_for_account_owner.buttonLabel)}
      content={t(info_boxes_messages.retention_for_account_owner.content, { remainingDays: retentionData.remainingDays })}
      showButton
      title={t(info_boxes_messages.retention_for_account_owner.title)}
    />
  );
};

export default DashboardInfoBoxRetentionForAccountOwner;
